import emailOutline from "./icons/email_outline.svg";
import lockOutline from "./icons/lock_outline.svg";
import SearcIcon from "./icons/search_icon.svg";
import ActionIcon from "./icons/actions_icon.svg";
import developmentIcon from "./icons/development_icon.svg";
import backIcon from "./icons/BackIcon.tsx";
import chartICon from "./icons/chart_icon.svg";
import appleIcon from "./icons/apple_icon.svg";
import eyeIcon from "./icons/eyes_icon.svg";
import bulpIllustration from "./illustrations/bulp_illustration.svg";
import rocketIllustration from "./illustrations/rocket_illustration.svg";
import facebookLogo from "./icons/facebook.svg";
import googleLogo from "./icons/google.svg";
import appleLogo from "./icons/apple.svg";
import passwordShowIcon from "./icons/passwordShow.svg";
import passwordHideIcon from "./icons/passwordHide.svg";
import resetKey from "./illustrations/reset_illustration.svg";
import security from "./illustrations/security_illustration.svg";
import { EyeOpened, FacebookIcon, GoogleIcon } from "./icons/icons";
import finishsetup from "./icons/finish_setup.svg";
import next from "./icons/Next.tsx";
import tick from "./icons/Tick.tsx";
import BulbOutlined from "./icons/bulb_outlined.tsx";
import SoloarDocument from "./icons/SoloarDocument.tsx";
import FluentThinking from "./icons/FLuentThinking.tsx";
import GridIconHelp from "./icons/GridIconHelp.tsx";
import Refresh from "./icons/Refresh.tsx";
import XpPoint from "./icons/xpPoint.tsx";
import play from "./icons/play.tsx";
// menu icons
import HomeFilled from "./icons/Home_filled.tsx";
import GraduationFilled from "./icons/Gradation_fiiled.tsx";
import PersonFill from "./icons/Person_fill.tsx";
import SettingFilled from "./icons/SettingFilled.tsx";
import SearchOutline from "./icons/SearchOutline.tsx";
import ShieldFilled from "./icons/ShieldFilled.tsx";
import SearchFilled from "./icons/SearchFilled.tsx";
import logo from "./icons/logo.svg";
import courseDummy from "./icons/dummy_course.svg";
import course2Dummy from "./icons/dummy_course2.svg";
import Streak from "./icons/streak.tsx";
import premium from "./illustrations/premium.svg";
// leagus
import leagueShield from "./illustrations/leagueShield.svg";
import clockFilled from "./icons/clock.svg";
import rank1 from "./icons/rank1.svg";
import rank2 from "./icons/rank2.svg";
import rank3 from "./icons/rank3.svg";

// badges
import amethyst from "./illustrations/badges/Amethyst.svg";
import bronze from "./illustrations/badges/bronze.svg";
import copper from "./illustrations/badges/copper.svg";
import defaultBadge from "./illustrations/badges/default.svg";
import diamond from "./illustrations/badges/diamond.svg";
import emarld from "./illustrations/badges/emarld.svg";
import gold from "./illustrations/badges/gold.svg";
import platinum from "./illustrations/badges/platinum.svg";
import ruby from "./illustrations/badges/ruby.svg";
import sapphire from "./illustrations/badges/sapphire.svg";
import silver from "./illustrations/badges/sliver.svg";
import ZoneArrow from "./icons/ZoneArrow.tsx";

// Lesson
import tile from "./illustrations/tile.svg";
import defaultTile from "./illustrations/learn.svg";
import lockTile from "./illustrations/locktile.svg";
import practiceTile from "./illustrations/practice.svg";
import SetOutlined from "./icons/SetOutlined.tsx";
import RepeatOutlined from "./icons/Repeat.tsx";
import MobileIcon from "./icons/Mobile.tsx";
import AdditionalPin from "./icons/Additional.tsx";

// profile
import ThunderFilled from "./icons/ThunderFIlled";
import questionRound from "./icons/Question.tsx";
import RotatedSquare from "./icons/RotageSquare.tsx";
import FunctionIcon from "./icons/function_iconn.tsx";
import PremiumStar from "./icons/Premiumstart.tsx";

export const assets = {
  icons: {
    SearcIcon,
    ActionIcon,
    developmentIcon,
    chartICon,
    appleIcon,
    eyeIcon,
    passwordHideIcon,
    passwordShowIcon,
    // leagues
    clockFilled,
    rank1,
    rank2,
    rank3,
    // social login
    facebookLogo,
    googleLogo,
    appleLogo,
    finishsetup,
    ThunderFilled,
    //logo
    logo,
    emailOutline,
    lockOutline,
    Refresh,
    play,
    SetOutlined,
    RepeatOutlined,
    FunctionIcon,
  },
  dummy: {
    // Add your dummy image paths here
    // todo: delete theme
    courseDummy,
    course2Dummy,
  },
  badges: {
    amethyst,
    bronze,
    copper,
    defaultBadge,
    diamond,
    emarld,
    gold,
    platinum,
    ruby,
    sapphire,
    silver,
  },
  iconComponents: {
    MobileIcon,
    backIcon,
    next,
    PremiumStar,
    SearchFilled,
    EyeOpened,
    FacebookIcon,
    tick,
    GoogleIcon,
    BulbOutlined,
    // Menu icons
    HomeFilled,
    GraduationFilled,
    SearchOutline,
    PersonFill,
    SettingFilled,
    ShieldFilled,
    Streak,
    // Leagues
    ZoneArrow,
    // profile
    ThunderFilled,
    questionRound,
    SoloarDocument,
    FluentThinking,
    GridIconHelp,
    XpPoint,
    RotatedSquare,
    AdditionalPin,
  },
  illustrations: {
    bulpIllustration,
    rocketIllustration,
    security,
    resetKey,
    premium,
    leagueShield,
    // lesson
    tile,
    defaultTile,
    practiceTile,
    lockTile,
  },
};
